import React from "react"
import { Container } from "../../styles/encouraging/Encouraging"

const Encouraging = () => {
    return (
        <Container>
            <article>
                <h1>
                    140,000+ people like you use Buffer to build
                    their brand on social media every month
                </h1>
                <button>Get started now</button>
            </article>
        </Container>
    )
}

export default Encouraging